import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { OwnerType } from '../paywall.models';

@Component({
    selector: 'upgrade-plan-dialog',
    templateUrl: './upgrade-plan-dialog.component.html',
    imports: [MatDialogModule, MatButtonModule, MatIconModule],
})
export class UpgradePlanDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<UpgradePlanDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { feature: string; planUuid: string; ownerType: OwnerType },
        private _router: Router,
    ) {}

    goToUpgrade(): void {
        this.dialogRef.close();
        const route = this.data.ownerType === 'tenant' ? '/tenant/paywall' : '/paywall';
        this._router.navigate([route], {
            queryParams: { feature: this.data.feature, tab: 'plans' },
        });
    }
}
